import React, { useState, useEffect, useMemo } from 'react';
import { history, useIntl, getLocale } from 'umi';
import { Segment, Justify } from 'tea-component';
import RangePicker from '@/pages/home/components/RangePicker';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import GenreSelector from '@intelligence/components/GenreSelectMiddleware';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import ExportTable from '@/pages/intelligence/components/ExportTable';
import '@/pages/intelligence/assets/scss/MarketProfile/TabDetails/Stats.scss';
// import useStatsModal from '@intelligence/pages/MarketProfile/TabDetails/hooks/useStatsModal.new';
import useStatsModal from '@intelligence/pages/MarketProfile/TabDetails/hooks/useStatsModal';
import { getUrlParam, convertDateFormat } from '@/pages/intelligence/pages/MarketProfile/_util';
import Loading from '@/pages/intelligence/components/Loading';
import NoData from '@/pages/intelligence/components/NoData';
import './index.scss';
import ChartCard from '@/pages/intelligence/pages/MarketProfile/TabDetails/components/LineChartCard';
import SearchRecent from '@/pages/intelligence/components/SearchRecent';
import OperationTable from '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/components/OperationTable';
import CompanyTable from '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/components/CompanyTable';
import GenreTable from '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/components/GenreTable';
import GameTable from '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/components/GameTable';
import { tableConfig } from '@/pages/intelligence/pages/MarketProfile/TabDetails/Stats/_config';
import moment from 'moment';
import { LANGUAGE_CN } from '@/pages/home/_config/config';
import { debounce } from 'lodash-es';
import { setShortcutOptionFun } from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { dbiPageLogMes } from '@/pages/intelligence/utils/buriedPointCfg';
import { buriedPointPage } from '@/pages/home/utils/buriedPoint';
import { getPageData } from '@/pages/intelligence/services/marketProfile';
import DataSourceSelector from '@/pages/intelligence/components/TeaSelector/AnnieSource';
import DigitalSegmentMultiple from '@/pages/intelligence/components/TeaSelector/DigitalSegmentMultiple';
import useSetQueryDefinition, {
  COND_PARAMS,
  FULL_GENRE,
  useQueryDefinition,
} from '@intelligence/hooks/useQueryDefinition';
import { marketProfileStats } from '@intelligence/v3/constants/downloadLogPoint';
import { useGenreMap } from '@/pages/intelligence/pages/MarketProfile/hooks/useGenreMap';

// 接口返回的字段映射
const RESPONSE_RESULT_GAMES_TABLE_KEY: {
  mobile: string;
  pc: string;
  console: string;
} = {
  mobile: 'market_detail_stats_games_ranks',
  pc: 'market_detail_stats_pc_games_ranks',
  console: 'market_detail_stats_pc_games_ranks',
};

const RESPONSE_RESULT_GAME_PALTFORM_KEY = {
  operation: 'opreatio_ranks',
  game: 'games_ranks',
  genre: 'genre_ranks',
  company: 'companies_ranks',
};

const PAGE_LOG_INFO_MAP: any = {
  mobile_operation: dbiPageLogMes.marketProfileStatsMobileOperationData,
  mobile_game: dbiPageLogMes.marketProfileStatsMobileByGames,
  mobile_genre: dbiPageLogMes.marketProfileStatsMobileByGenres,
  mobile_company: dbiPageLogMes.marketProfileStatsMobileByCompanies,
  pc_operation: dbiPageLogMes.marketProfileStatsPCOperationData,
  pc_game: dbiPageLogMes.marketProfileStatsPCByGames,
  pc_genre: dbiPageLogMes.marketProfileStatsPCByGenres,
  pc_company: dbiPageLogMes.marketProfileStatsPCByCompanies,
  console_operation: dbiPageLogMes.marketProfileStatsConsoleOperationData,
  console_game: dbiPageLogMes.marketProfileStatsConsoleByGames,
  console_genre: dbiPageLogMes.marketProfileStatsConsoleByGenres,
  console_company: dbiPageLogMes.marketProfileStatsConsoleByCompanies,
};

export default function MarketTabDetailsStats(props: any) {
  const { marketName, marketNameEn, pageId, segment, changeSegment, setActiveId, activeId, regionOptions } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { ieggGenreMap } = useGenreMap();
  const [countryId, setCountryId] = useState('');
  const countryList = ['us', 'de', 'gb', 'fr', 'es'];
  const [gameTypeDisable, setGameTypeDisable] = useState(false);

  const {
    gameType,
    dataType,
    trendType,
    setTrendType,
    setGameType,
    setDataType,
    gameSortFiled,
    setGameSortFiled,
    setDownloadOrder,
    setDownloadDataTag,
    setPageSize,
    sortColunms,
    sortOrder,
    setSortColunms,
    getGenresData,
    getGamesData,
    value,
    setValue,
    getOperationData,
    resizeHandler,
    showTableData,
    changeTableSort,
    sumRevenue,
    sumDownload,
    onGameTypeChange,
    onDataTypeChange,
    dateType,
    tableDataLoad,
    selectedKeys,
    setSelectedKeys,
    selectedAllKeys,
    setSelectedKeysColor,
    selectedKeysColor,
    getGamesTrendData,
    gameTrendsData,
    getCompaneiesTrendData,
    setCompaneiesTrendData,
    handleGamesSortChange,
    color,
    pcColor,
    operationTrendsData,
    onChangeRangePicker,
    componentDefaultValues,
    mainGenres,
    subGenres,
    genreRef,
    pcGenreChange,
    gameSortRelation,
    searchKey,
    searchData,
    ieggGenre,
    filterData,
    setSearchKey,
    SearchBoxRef,
    lineDataLoad,
    getGenresReqParams,
    tableLength,
    setPageIndex,
    pageIndex,
    expandedKeys,
    setExpandedKeys,
    selectId,
    setSelectId,
    selectChildren,
    setSelectChildren,
    subValue,
    pageSize,
    getDefaultSortkeyWhenGames,
    handleCompanySortChange,
    dataSource,
    onChangeDataSource,
    mainGenreList,
    onChangeMainGenre,
  } = useStatsModal({
    marketName,
    marketNameEn,
    pageId,
    segment,
    changeSegment,
    setActiveId,
    countryId,
    regionOptions,
    genreMap: ieggGenreMap,
  });


  const { MobileGameList, PCGameList, ConsoleGameList } = tableConfig;
  const [list, setList] = useState<any>(MobileGameList?.OperationData || {});

  const isAnnie: any = useMemo(() => history.location.query?.isAnnie, [history.location]);

  const pageID = useMemo(() => `${gameType}_${dataType}`, [gameType, dataType]);

  const pageLogInfo = useMemo(
    () => PAGE_LOG_INFO_MAP[`${gameType}_${dataType}`],
    [gameType, dataType],
  );

  useEffect(() => {
    const marketNameEnCur = marketNameEn || history.location.query.marketNameEn;
    setCountryId(marketNameEnCur);

    // PC console选项是否可用，只有 countryList 中的国家才可用
    const countryHasPcConsoleData = countryList.indexOf(marketNameEnCur) == -1;
    setGameTypeDisable(countryHasPcConsoleData);

    let type = 'mobile';
    const segmentFromOtherPage = getUrlParam('segment');
    /**
     * stat entity_type只有mobile、pc、console，所以如果没有在countryList中，则默认全为mobile。
     */
    if (segmentFromOtherPage != '' && segmentFromOtherPage != 'total' && !countryHasPcConsoleData) {
      type = segmentFromOtherPage;
      gameSortFiled.length = 0;
      gameSortFiled.push(getDefaultSortkeyWhenGames(segmentFromOtherPage));
      setGameSortFiled(gameSortFiled);
    }
    setGameType(type);

    // 从url参数中获取维度数据（operaion、games、genres、companies）
    let dimension = getUrlParam('dimension');
    // 如果没有，默认展示第一个页签
    if (!dimension) {
      dimension = 'operation';
    }
    setDataType(dimension);

    // 从浏览器参数中获取insight页面传递过来的时间范围，用于继承
    const date = getUrlParam('dateRange');
    const { startDate, endDate } = convertDateFormat(date);

    localStorage.setItem('genreSourceTemp', type == 'mobile' ? 'annie' : 'iegg');

    const dataTypeJ = getUrlParam('genreJump');
    let dt = dimension;
    if (dataTypeJ != '') {
      dt = 'genre';
      setDataType('genre');
    }
    const _params = {
      market: marketNameEnCur,
      entity_type: type,
      genre: [],
      data_tag: dt,
      start_date: startDate,
      end_date: endDate,
      page: 1,
      page_size: 50,
      order: 'desc',
      order_by: getDefaultSortkeyWhenGames(type),
      granularity: 'monthly',
      iegg_genre_req: [],
    };
    setDownloadOrder('desc');
    setDownloadDataTag(dt);
    if (dataTypeJ) {
      setTrendType('revenue');
      setPageSize(50);
      if (gameType == 'mobile') {
        sortColunms.length = 0;
        sortColunms.push(...['genreMobileRevenue']);
        setSortColunms(sortColunms);
      } else if (gameType == 'pc') {
        sortColunms.length = 0;
        sortColunms.push(...['gameRevenueD']);
        setSortColunms(sortColunms);
      } else if (gameType == 'console') {
        sortColunms.length = 0;
        sortColunms.push(...['gameRevenueD']);
        setSortColunms(sortColunms);
      }
      getGenresData(_params, true, dataTypeJ);
    } else if (dimension && dimension === 'game') {
      // 当从insight页面跳转过来时，直接走game逻辑
      getGamesData(_params, false);
      setList(MobileGameList.GamesData);
      setValue([moment(startDate), moment(endDate)]);
    } else {
      // 默认会走operation的逻辑
      getOperationData(_params, true);
    }

    window.addEventListener('resize', resizeHandler);
    return () => {
      window.removeEventListener('resize', resizeHandler);
    };
  }, []);

  const changeSelectedKeysColor = (val: any) => {
    setSelectedKeysColor(val);
  };

  const { scrollBody } = props;
  const [segmentFixed, setSegmentFixed] = useState(false);

  // 请求参数
  const fetchParams = useMemo(
    () => ({
      market: countryId,
      entity_type: gameType,
      genre: [],
      // 参数中data_tag是games
      data_tag: dataType === 'game' ? 'games' : dataType,
      start_date: value.length == 2 ? value[0].format('YYYY-MM-DD') : '',
      end_date: value.length == 2 ? value[1].format('YYYY-MM-DD') : '',
      page: 1,
      page_size: 50,
      order: 'desc',
      order_by: gameSortRelation[sortColunms[0]]
        ? gameSortRelation[sortColunms[0]]
        : getDefaultSortkeyWhenGames(gameType),
      granularity: dateType == 'month' ? 'monthly' : dateType == 'week' ? 'weekly' : 'daily',
      select_code: [],
    }),
    [countryId, gameType, dataType, value, gameSortRelation, sortColunms, dateType],
  );

  const changeSelectedKeys = async (val: any) => {
    setSelectedKeys(val);
    if (dataType && dataType === 'game') {
      getGamesTrendData(val?.map((item: any) => item.gameId));
    }
    if (dataType && dataType === 'company') {
      const selectCode = val?.map((item: any) => item.gameId) || [];
      const { granularity, entity_type: gameType } = fetchParams;
      const trendData = await getCompaneiesTrendData(selectCode, fetchParams);
      setCompaneiesTrendData(selectCode, gameType, granularity, trendData);
    }
  };

  // 清除搜索时的回调
  const handleClearSearch = () => {
    getTableSearchList('');
  };

  // 获取搜索列表数据
  const getTableSearchList = (keyword?: string) => {
    if (dataType != 'game') {
      filterData(keyword);
    } else {
      // TODO: 这里改了data_tag，需要测试
      getGamesData(
        {
          ...fetchParams,
          select_code: keyword?.trim() == '' ? null : [keyword],
        },
        false,
      );
    }
  };

  // 搜索调用的接口
  const searchListApi = async (params: any) => await getPageData('detail/stats_rank', params);

  // 自定义渲染
  const renderNotGame = (item: any, Func: any) => (
    <div onClick={() => Func.triggerCompClick(item)}>{item.id}</div>
  );

  // 搜索回调后参数的格式化
  const transTableDataForSearch = (params: any) => {
    const optionList: any[] = [];
    const inputValue = dataType !== 'game' ? params : '';
    const gameResultList =
      dataType === 'game'
        ? params[RESPONSE_RESULT_GAME_PALTFORM_KEY.game][
            RESPONSE_RESULT_GAMES_TABLE_KEY?.[gameType]
          ]
        : [];
    switch (dataType) {
      case 'game':
        gameResultList?.forEach((item: any) => {
          optionList.push({
            id: item.app_id,
            imgSrc: item?.cover,
            lineOneStr: item.name,
            lineTwoImgName: item.country_img,
            lineTwoStr: item.publisher,
          });
        });
        break;
      case 'company':
        searchData.forEach((item: any) => {
          if (item.name.toLowerCase().indexOf(inputValue.toLowerCase()) != -1) {
            optionList.push({
              id: item.name,
              imgSrc: item?.companyIcon,
              lineOneStr: item.name,
              lineTwoImgName: item.conutryFlag,
              lineTwoStr: item.conutryName,
            });
          }
        });
        break;
      case 'genre':
        searchData.forEach((item: any) => {
          const genreDisplayName = item?.displayName || item?.genreName || '';
          const matchedByRaw = item?.genreName?.toLowerCase()?.indexOf(inputValue?.toLowerCase()) != -1;
          const matchedByDisplay = genreDisplayName.toLowerCase().indexOf(inputValue?.toLowerCase()) != -1;
          if (matchedByRaw || matchedByDisplay) {
            optionList.push({
              id: item.genreName,
              lineOneStr: genreDisplayName,
            });
          }
        });
        break;
      default:
        break;
    }
    return optionList;
  };

  // 监听页面滚动
  useEffect(() => {
    if (scrollBody.current) {
      const handleScroll = debounce((e: any) => {
        const { scrollTop } = e.srcElement;
        // console.log(scrollTop);

        // 滚动判断距离 和定位条位置相关，开发调整
        if (scrollTop > 260) {
          setSegmentFixed(true);
        } else {
          setSegmentFixed(false);
        }
      }, 100);
      scrollBody.current?.addEventListener('scroll', handleScroll, false);
      return () => scrollBody.current?.removeEventListener('scroll', handleScroll, false);
    }
  }, [scrollBody]);

  useEffect(() => {
    if (pageLogInfo) {
      buriedPointPage(pageLogInfo);
    }
  }, [pageLogInfo]);

  const onPagingChange = (params: any) => {
    if (dataType == 'game') {
      const _params = {
        market: countryId,
        entity_type: gameType,
        genre: subValue,
        data_tag: dataType,
        start_date: value.length == 2 ? value[0].format('YYYY-MM-DD') : '',
        end_date: value.length == 2 ? value[1].format('YYYY-MM-DD') : '',
        page: params.pageIndex,
        page_size: params.pageSize,
        order: 'desc',
        order_by: gameSortRelation[sortColunms[0]]
          ? gameSortRelation[sortColunms[0]]
          : getDefaultSortkeyWhenGames(gameType),
        granularity: dateType == 'month' ? 'monthly' : dateType == 'week' ? 'weekly' : 'daily',
        select_code: searchKey?.length > 0 ? searchKey : null,
      };
      setDownloadOrder('desc');
      setDownloadDataTag(dataType);
      getGamesData(_params, false, true);
    } else if (dataType == 'genre') {
      expandedKeys.length == 0;
      setExpandedKeys([]);
      setSelectId('');
      selectChildren.length == 0;
      setSelectChildren([]);
    }
    setPageIndex(params.pageIndex);
    setPageSize(params.pageSize);
  };

  // 使用统一全局存储数据
  const { condDatas, filterLoading } = useSetQueryDefinition({ ...COND_PARAMS.mobileMainGenre });

  // 获取主品类筛选器选项
  const mainGenreOptions = useMemo(() => {
    if (filterLoading) return [];
    const genreListTemp = condDatas?.mobileMainGenre || [];
    return genreListTemp?.map((itemValue: string) => {
      const iegGenreList = FULL_GENRE?.ieg || [];
      const itemGenreObj = iegGenreList?.find((item: any) => item?.main_genre?.genre == itemValue);
      let textValue = itemValue;
      if (itemGenreObj) {
        textValue =
          locale === LANGUAGE_CN
            ? itemGenreObj?.main_genre?.genre_cn
            : itemGenreObj?.main_genre?.genre_en;
      }
      return {
        value: itemValue,
        text: textValue,
      };
    });
  }, [condDatas, filterLoading, locale]);

  return (
    <div className="dbi-market-tabdetails--stats">
      <div className="dbi-market-tabdetails-segment">
        <Segment
          className="segment-light"
          value={gameType}
          // disabled={tableDataLoad}
          onChange={(value: any) => {
            onGameTypeChange(value);
            setList({});
            if (value == 'mobile') {
              setList(MobileGameList.OperationData);
            } else if (value == 'pc') {
              setList(PCGameList.OperationData);
            } else if (value == 'console') {
              setList(ConsoleGameList.OperationData);
            }

            history.replace(
              `/intelligence/marketProfile/${activeId}/detail?marketName=${marketName}&marketNameEn=${marketNameEn}&pageId=${pageId}&segment=${value}${
                isAnnie ? `&isAnnie=${isAnnie}` : ''
              }`,
            );
          }}
          options={[
            {
              text: formatMessage({ id: 'dbi_market_mobile' }),
              value: 'mobile',
            },
            {
              text: formatMessage({ id: 'dbi_market_pc' }),
              value: 'pc',
              disabled: gameTypeDisable,
            },
            {
              text: formatMessage({ id: 'dbi_market_console' }),
              value: 'console',
              disabled: gameTypeDisable,
            },
          ]}
        />
        <Segment
          className="segment-light"
          value={dataType}
          disabled={tableDataLoad}
          onChange={(value: any) => {
            onDataTypeChange(value);
            setList({});
            if (gameType == 'mobile') {
              if (value == 'operation') {
                setList(MobileGameList.OperationData);
              } else if (value == 'game') {
                setList(MobileGameList.GamesData);
              } else if (value == 'genre') {
                setList(MobileGameList.GanresData);
              } else if (value == 'company') {
                setList(MobileGameList.CompaniesData);
              }
            } else if (gameType == 'pc') {
              if (value == 'operation') {
                setList(PCGameList.OperationData);
              } else if (value == 'game') {
                setList(PCGameList.GamesData);
              } else if (value == 'genre') {
                setList(PCGameList.GanresData);
              } else if (value == 'company') {
                setList(PCGameList.CompaniesData);
              }
            } else if (gameType == 'console') {
              if (value == 'operation') {
                setList(ConsoleGameList.OperationData);
              } else if (value == 'game') {
                setList(ConsoleGameList.GamesData);
              } else if (value == 'genre') {
                setList(ConsoleGameList.GanresData);
              } else if (value == 'company') {
                setList(ConsoleGameList.CompaniesData);
              }
            }
          }}
          options={[
            { text: formatMessage({ id: 'dbi_market_operation_data' }), value: 'operation' },
            { text: formatMessage({ id: 'dbi_market_by_game' }), value: 'game' },
            { text: formatMessage({ id: 'dbi_market_by_genres' }), value: 'genre' },
            { text: formatMessage({ id: 'dbi_market_by_companies' }), value: 'company' },
          ]}
        />
        {gameType == 'mobile' ? (
          <TipContext
            className="tip-text-hd"
            tipText={
              <div style={{ whiteSpace: 'pre-wrap', maxWidth: '280px' }}>
                {formatMessage({ id: 'dbi_market_tip_text' })}
              </div>
            }
          />
        ) : (
          ''
        )}
      </div>

      {/* 吸顶内容 */}
      <div className={`header-segment ${segmentFixed ? 'visible' : 'hide'}`}>
        <div className="dbi-market-tabdetails-segment">
          <Segment
            value={gameType}
            disabled={tableDataLoad}
            onChange={(value: any) => {
              onGameTypeChange(value);
              setList({});
              if (value == 'mobile') {
                setList(MobileGameList.OperationData);
              } else if (value == 'pc') {
                setList(PCGameList.OperationData);
              } else if (value == 'console') {
                setList(ConsoleGameList.OperationData);
              }

              history.replace(
                `/intelligence/marketProfile/${activeId}/detail?marketName=${marketName}&marketNameEn=${marketNameEn}&pageId=${pageId}&segment=${value}${
                  isAnnie ? `&isAnnie=${isAnnie}` : ''
                }`,
              );
            }}
            options={[
              {
                text: formatMessage({ id: 'dbi_market_mobile' }),
                value: 'mobile',
              },
              {
                text: formatMessage({ id: 'dbi_market_pc' }),
                value: 'pc',
                disabled: gameTypeDisable,
              },
              {
                text: formatMessage({ id: 'dbi_market_console' }),
                value: 'console',
                disabled: gameTypeDisable,
              },
            ]}
          />
          <Segment
            value={dataType}
            disabled={tableDataLoad}
            onChange={(value: any) => {
              onDataTypeChange(value);
              setList({});
              if (gameType == 'mobile') {
                if (value == 'operation') {
                  setList(MobileGameList.OperationData);
                } else if (value == 'game') {
                  setList(MobileGameList.GamesData);
                } else if (value == 'genre') {
                  setList(MobileGameList.GanresData);
                } else if (value == 'company') {
                  setList(MobileGameList.CompaniesData);
                }
              } else if (gameType == 'pc') {
                if (value == 'operation') {
                  setList(PCGameList.OperationData);
                } else if (value == 'game') {
                  setList(PCGameList.GamesData);
                } else if (value == 'genre') {
                  setList(PCGameList.GanresData);
                } else if (value == 'company') {
                  setList(PCGameList.CompaniesData);
                }
              } else if (gameType == 'console') {
                if (value == 'operation') {
                  setList(ConsoleGameList.OperationData);
                } else if (value == 'game') {
                  setList(ConsoleGameList.GamesData);
                } else if (value == 'genre') {
                  setList(ConsoleGameList.GanresData);
                } else if (value == 'company') {
                  setList(ConsoleGameList.CompaniesData);
                }
              }
            }}
            options={[
              { text: formatMessage({ id: 'dbi_market_operation_data' }), value: 'operation' },
              { text: formatMessage({ id: 'dbi_market_by_game' }), value: 'game' },
              { text: formatMessage({ id: 'dbi_market_by_genres' }), value: 'genre' },
              { text: formatMessage({ id: 'dbi_market_by_companies' }), value: 'company' },
            ]}
          />
          {gameType === 'mobile' ? (
            <TipContext
              className="tip-text-hd"
              tipText={
                <div style={{ whiteSpace: 'pre-wrap', maxWidth: '280px' }}>
                  {formatMessage({ id: 'dbi_market_tip_text' })}
                </div>
              }
            />
          ) : (
            ''
          )}
        </div>
      </div>

      <div className="tabdetails-rowtop">
        {/* 开发进行数据传输 */}
        <Justify
          className="tabdetails-filter"
          left={
            <>
              {dataType !== 'company' && (dataType === 'game' || gameType !== 'mobile') && (
                <div className="search-item">
                  <GenreSelector
                    className="stats-select"
                    ref={genreRef}
                    source={'iegg'}
                    mainGenres={mainGenres}
                    subGenres={subGenres}
                    onChange={pcGenreChange}
                    disableAnnie={true}
                    disableShortcut={false}
                    isMarketProfilMobile={true}
                    entityType={gameType}
                  />
                </div>
              )}

              {dataType !== 'company' && dataType !== 'game' && gameType === 'mobile' ? (
                <div className="search-item">
                  <DigitalSegmentMultiple
                    key={'digital_segment_multiple'}
                    value={mainGenreList}
                    locale={locale}
                    optionsOutList={mainGenreOptions}
                    isNeedHeaderTitle={false}
                    btnNameKey={'dbi_top_genre'}
                    onConfirm={onChangeMainGenre}
                  />
                </div>
              ) : (
                ''
              )}

              {/* 仅占位*/}
              <div className="search-item search-item-date">
                <RangePicker
                  value={value}
                  language={locale === LANGUAGE_CN ? 'cn' : 'en'}
                  defaultValue={componentDefaultValues}
                  type={dateType}
                  setShortcutOption={() => setShortcutOptionFun(dateType)}
                  className="search-border"
                  typeList={
                    dataType === 'company' && gameType === 'mobile'
                      ? ['month']
                      : ['date', 'week', 'month']
                  }
                  showSelectType={!(dataType === 'company' && gameType === 'mobile')}
                  startOfWeek={1}
                  isReseted={true}
                  // onChange={onChangeRangePicker}
                  onChange={(value: any, type: string) => {
                    let dateValue = ['', ''];
                    // 月粒度时，enddate为当前月的最后一天而不是第一天
                    if (Array.isArray(value) && value.length === 2) {
                      const startDate = value[0];
                      let endDate = value[1];
                      /** 切换左侧日周月时，因为默认值为空，所以这里默认值给切换的值 */
                      if (startDate === '' && endDate === '') {
                        dateValue = componentDefaultValues[type];
                      } else {
                        if (type === 'month') {
                          // 月粒度为 1-31号的格式
                          endDate = moment(endDate).endOf('month');
                        }
                        dateValue = [startDate, endDate];
                      }
                    }
                    onChangeRangePicker(dateValue, type);
                  }}
                />
              </div>

              {/* {gameType === 'mobile' && (
                <DataSourceSelector
                  type={'single'}
                  key={'dataSourceSingle'}
                  locale={locale}
                  onConfirm={onChangeDataSource}
                  value={dataSource}
                  isSearchItemMargin={true}
                />
              )} */}

              {gameType !== 'mobile' ? (
                <TipContext
                  className="tip-text-hd tip-text-market"
                  tipText={formatMessage({ id: 'dbi_market_tip_text_mscience' })}
                />
              ) : (
                ''
              )}
            </>
          }
          right={
            <ExportTable
              classModalName="dbi-top-companies-download-modal"
              useWebDownload
              entityType={gameType}
              dataType={dataType}
              downloadModalSize={820}
              businessType={'marketProfile-stats'}
              isDisableDownload={lineDataLoad}
              total={tableLength}
              tableParams={getGenresReqParams()}
              // downloadKey={'marketProfileStats'}
              downloadKey={'marketProfileStatsNew'}
              downloadLogConfigKey={marketProfileStats?.[`${gameType}_${dataType}`]}
            />
          }
        />
      </div>

      <CardSlot
        title={formatMessage({ id: list.title })}
        iconList={null}
        className="dbi-stats-data dbi-marketprofile-chart-h"
      >
        {lineDataLoad ? (
          <div style={{ height: 310 }}>
            <Loading content={formatMessage({ id: 'common_loading' })} />
          </div>
        ) : (selectedKeys?.length == 0 && dataType !== 'operation') ||
          (dataType == 'operation' && operationTrendsData.data?.length == 0) ? (
          <div style={{ height: 310 }}>
            <NoData content={formatMessage({ id: 'common_nodata' })} />
          </div>
        ) : (
          <ChartCard
            list={list}
            selectedKeys={selectedKeys}
            gameTrendsData={gameTrendsData}
            gameType={gameType}
            color={color}
            pcColor={pcColor}
            trendType={trendType}
            dataType={dataType}
            selectedKeysColor={selectedKeysColor}
            sumRevenue={sumRevenue}
            sumDownload={sumDownload}
            operationTrendsData={operationTrendsData}
          />
        )}
      </CardSlot>
      {dataType !== 'operation' ? (
        <Justify
          className="dbi-stats-justify"
          right={
            <SearchRecent
              key={pageID}
              // 传入搜索的filter_ids要为[],不然后端会返回filter_ids里的游戏列表
              fetchParams={fetchParams}
              handleClear={handleClearSearch}
              getTableResultList={getTableSearchList}
              searchListApi={searchListApi}
              pageLogInfo={pageLogInfo}
              placeholder={formatMessage(
                {
                  id: 'dbi_search_in_table',
                },
                {
                  type:
                    dataType === 'game'
                      ? formatMessage({ id: 'dbi_game' })
                      : dataType === 'genre'
                      ? formatMessage({ id: 'dbi_global_view_genre' })
                      : formatMessage({ id: 'dbi_company' }),
                },
              )}
              isCustomRendering={dataType === 'genre'}
              searchType={`MPStats_${pageID}`}
              searchKey={'keyword'}
              isFrontEndSearch={dataType !== 'game'}
              transTableDataForSearch={transTableDataForSearch}
              initSearchInput={`${pageID}`}
              renderComp={renderNotGame}
            />
          }
        />
      ) : (
        ''
      )}
      <CardSlot>
        <div className="dbi-stats-table">
          {tableDataLoad ? (
            <div style={{ height: 425 }}>
              <Loading content={formatMessage({ id: 'common_loading' })} />
            </div>
          ) : showTableData && showTableData.length > 0 ? (
            dataType == 'operation' ? (
              <OperationTable
                showTableData={showTableData}
                changeTableSort={changeTableSort}
                sortColunms={sortColunms}
                gameType={gameType}
                tableLength={tableLength}
                onPagingChange={onPagingChange}
                dataType={dataType}
                pageSize={pageSize}
                pageIndex={pageIndex}
              />
            ) : dataType == 'company' ? (
              <CompanyTable
                showTableData={showTableData}
                // changeTableSort={changeTableSort}
                onCompanySortChange={handleCompanySortChange}
                sortColunms={sortColunms}
                sortOrder={sortOrder}
                gameType={gameType}
                selectedKeys={selectedKeys}
                selectedAllKeys={selectedAllKeys}
                changeSelectedKeys={changeSelectedKeys}
                changeSelectedKeysColor={changeSelectedKeysColor}
                tableLength={tableLength}
                onPagingChange={onPagingChange}
                dataType={dataType}
                pageSize={pageSize}
                pageIndex={pageIndex}
              />
            ) : dataType == 'game' ? (
              <GameTable
                countryId={countryId}
                dateType={dateType}
                showTableData={showTableData}
                // changeTableSort={changeTableSort}
                onGamesSortChange={handleGamesSortChange}
                sortColunms={sortColunms}
                sortOrder={sortOrder}
                gameType={gameType}
                selectedKeys={selectedKeys}
                selectedAllKeys={selectedAllKeys}
                changeSelectedKeys={changeSelectedKeys}
                changeSelectedKeysColor={changeSelectedKeysColor}
                tableLength={tableLength}
                onPagingChange={onPagingChange}
                dataType={dataType}
                pageSize={pageSize}
                pageIndex={pageIndex}
                tableDataLoad={tableDataLoad}
              />
            ) : dataType == 'genre' ? (
              <GenreTable
                countryId={countryId}
                showTableData={showTableData}
                changeTableSort={changeTableSort}
                sortColunms={sortColunms}
                gameType={gameType}
                selectedKeys={selectedKeys}
                selectedAllKeys={selectedAllKeys}
                changeSelectedKeys={changeSelectedKeys}
                changeSelectedKeysColor={changeSelectedKeysColor}
                tableLength={tableLength}
                onPagingChange={onPagingChange}
                dataType={dataType}
                pageSize={pageSize}
                pageIndex={pageIndex}
              />
            ) : (
              <></>
            )
          ) : (
            <div style={{ height: 310 }}>
              <NoData content={formatMessage({ id: 'common_nodata' })} />
            </div>
          )}
        </div>
      </CardSlot>
    </div>
  );
}
